import React, { PureComponent } from 'react'
import { Route, Switch } from 'react-router-dom'
import ProgressReportsOverview from '../containers/progress-reports-overview'
import ProgressReportsThemes from '../containers/progress-reports-themes'
import ProgressReportsTheme from '../containers/progress-reports-theme'
import ProgressReportsDrivers from '../containers/progress-reports-drivers'
import ProgressReportsStatements from '../containers/progress-reports-statements'
import { Redirect } from 'react-router-dom'
import { formPagePath } from '../utilities/route'

class ProgressReports extends PureComponent {
  render() {
    const {
      match: {
        path,
        params: { surveyId, languageCode },
      },
      questionnaire: {
        areProgressReportsActive
      },
    } = this.props;

    // Handle redirects if progress reports is not available
    if (!areProgressReportsActive) {
      return <Redirect push to={formPagePath(languageCode, surveyId, 'finish')}/>
    }

    return (
      <section className="finish-page">
        <Switch>
          <Route
            path={`${path}/themes`}
            component={() => <ProgressReportsThemes {...this.props} />}
          />
          <Route
            path={`${path}/theme/:catalystId`}
            component={() => <ProgressReportsTheme {...this.props} />}
          />
          <Route
            path={`${path}/drivers`}
            component={() => <ProgressReportsDrivers {...this.props} />}
          />
          <Route
            path={`${path}/statements`}
            component={() => <ProgressReportsStatements {...this.props} />}
          />
          <Route
            path={`${path}`}
            component={() => <ProgressReportsOverview {...this.props} />}
          />
        </Switch>
      </section>
    );
  }
}

export default ProgressReports;



// WEBPACK FOOTER //
// ./src/components/progress-reports.js